import { CheckCircle, TrendingUp, Clock, FileText, X, Ban } from "lucide-react";

// Database status mapping to UI display
export const statusDisplayMap = {
  'draft': 'Draft',
  'pending': 'Pending response',
  'accepted': 'Accepted',
  'rejected': 'Rejected',
  'cancelled': 'Cancelled',
  'overdue': 'Overdue'
} as const;

export const statusOptions = ["draft", "pending", "accepted", "rejected", "cancelled"];

export const getStatusColor = (status: string) => {
  switch (status) {
    case "draft": return "bg-gray-100 text-gray-800";
    case "accepted": return "bg-green-100 text-green-800";
    case "pending": return "bg-sky-100 text-sky-800";
    case "overdue": return "bg-sky-100 text-sky-800";
    case "rejected": return "bg-red-100 text-red-800";
    case "cancelled": return "bg-orange-100 text-orange-800";
    default: return "bg-gray-100 text-gray-800";
  }
};

export const getStatusIcon = (status: string) => {
  switch (status) {
    case "draft": return FileText;
    case "accepted": return CheckCircle;
    case "pending": return TrendingUp;
    case "overdue": return Clock;
    case "rejected": return X;
    case "cancelled": return Ban;
    default: return Clock;
  }
};

// Utility function to determine proposal status based on response deadline
export const getProposalStatus = (proposal: { status?: string; sent_date?: string; response_deadline?: string }) => {
  // Preserve terminal statuses
  if (proposal.status === 'accepted' || proposal.status === 'rejected' || proposal.status === 'cancelled') {
    return proposal.status;
  }
  
  // If no sent_date, it's a draft
  if (!proposal.sent_date) {
    return 'draft';
  }
  
  // If no response deadline, keep as pending
  if (!proposal.response_deadline) {
    return 'pending';
  }
  
  // Check if deadline has passed
  const deadline = new Date(proposal.response_deadline);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  deadline.setHours(0, 0, 0, 0);
  
  if (deadline < today) {
    return 'overdue';
  }
  
  return 'pending';
};

// Type definitions
export type ProposalStatus = keyof typeof statusDisplayMap;
